import { createContext, useContext, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useNavigate, useLocation } from "react-router-dom";

const FeiraContext = createContext();

export const FeiraProvider = ({ children, idFeira, maxWidth = 500, forceMobile = false }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { api } = require("../config");
  const mapRef = useRef(null);
  
  // const mapaRegistradoRef = useRef(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mapData, setMapData] = useState(null);
  const [fundoImagem, setFundoImagem] = useState(null);
  const [fundoImagemMobile, setFundoImagemMobile] = useState(null);
  const [legenda, setLegenda] = useState([]);
  const [selectedEstandeInfo, setSelectedEstandeInfo] = useState(null);
  const [estandeClicado, setEstandeClicado] = useState(false);
  const [animationKey, setAnimationKey] = useState(0);
  const [reservaConfirmada, setReservaConfirmada] = useState(false);
  const [mapaDeReserva, setMapaDeReserva] = useState(false);
  const [scale, setScale] = useState(1);
  const [modoRenovacao, setModoRenovacao] = useState(false);
  const [mensagemPadrao, setMensagemPadrao] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [openModalSucesso, setOpenModalSucesso] = useState(true);
  const [openModalRenovacoes, setOpenModalRenovacoes] = useState(false);
  const [showModalConfirmado, setShowModalConfirmado] = useState(false);
  const [openModalWhatsapp, setOpenModalWhatsapp] = useState(false);
  const [openModalQueroExpor, setOpenModalQueroExpor] = useState(false);
  const [openModalRenovacao, setOpenModalRenovacao] = useState(false);
  const [openModalRenovacaoReserva, setOpenModalRenovacaoReserva] = useState(false);
  const [mapLoading, setMapLoading] = useState(true);
  const [estandesMap, setEstandesMap] = useState(new Map());
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [filtros, setFiltros] = useState({
    valorMax: "",
    valorMin: "",
    alturaMin: "",
    alturaMax: "",
    areaMin: "",
    areaMax: "",
    nome: ""
  });
  const [estaFiltrado, setEstaFiltrado] = useState(false);
  const [filteredHashes, setFilteredHashes] = useState(new Set());
  const [labelsTick, setLabelsTick] = useState(0);
  const [estandeAlugado, setEstandeAlugado] = useState(false);
  const [mensagemEstandeAlugado, setMensagemEstandeAlugado] = useState(false);
  const [statusDoEstande, setStatusDoEstande] = useState([]);
  const [statusReserva, setStatusReserva] = useState([]);
  const [estandesCadastrados, setEstandesCadastrados] = useState([]);
  const [paises, setPaises] = useState([]);
  const [formaPagamentoId, setFormaPagamentoId] = useState("");
  const [comercialId, setComercialId] = useState("");
  const [condicaoPagamentoId, setCondicaoPagamentoId] = useState("");
  const [observacao, setObservacao] = useState("");
  const [cnpjCi, setCNPJCi] = useState("");
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [logo, setLogo] = useState("");
  const [endereco, setEndereco] = useState("");
  const [estado, setEstado] = useState("");
  const [cep, setCep] = useState("");
  const [cidade, setCidade] = useState("");
  const [pais, setPais] = useState("");
  const [termos, setTermos] = useState(false);
  const [contrato, setContrato] = useState(false);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingEstandes, setLoadingEstandes] = useState(false);
  const [error, setError] = useState(null);
  const [corPrincipal, setCorPrincipal] = useState(null);
  const [logoDesenvolvedorMapa, setLogoDesenvolvedorMapa] = useState(null);
  const [banner, setBanner] = useState(null);
  const [bannerMobile, setBannerMobile] = useState(null);
  const [corSecundaria, setCorSecundaria] = useState(null);
  const [whatsappPrincipal, setWhatsappPrincipal] = useState(null);
  const [nomeFeira, setNomeFeira] = useState(null);
  const [corPlanoFundo, setCorPlanoFundo] = useState(null);
  const [corPendenteRenovacao, setCorPendenteRenovacao] = useState(null);
  const [camposRenovacao, setCamposRenovacao] = useState([]);
  const [configuracao, setConfiguracao] = useState([]);
  const [erroCampoVazio, setErroCampoVazio] = useState(false);
  const [mostrarMapaGeral, setMostrarMapaGeral] = useState(false);
  const [openMobile, setOpenMobile] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < maxWidth);
  const [dadosProntos, setDadosProntos] = useState(false);
  const [emailRenovacao, setEmailRenovacao] = useState("");
  const [corRenovacao, setCorRenovacao] = useState("");
  const [corLivre, setCorLivre] = useState("");
  const [corReservado, setCorReservado] = useState("");
  const [corVendido, setCorVendido] = useState("");
  const [acessoRenovacaoLiberado, setAcessoRenovacaoLiberado] = useState(false);
  const [modalAviso, setModalAviso] = useState({
    isOpen: false,
    titulo: "",
    mensagem: ""
  });

 const exibirAviso = (titulo, mensagem) => {
   setModalAviso({
     isOpen: true,
     titulo: titulo,
     mensagem: mensagem
   });
 };

 const lastWidth = useRef(window.innerWidth);

 useEffect(() => {
    const checkIsMobile = () => {
      const currentWidth = window.innerWidth;
      
      // SÓ executa a lógica se a LARGURA mudar (ignora altura/barra de endereço)
      if (currentWidth !== lastWidth.current) {
        lastWidth.current = currentWidth;
        
        const isSmallScreen = currentWidth <= maxWidth;
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isMobileUA = /android|iphone|ipad|ipod/i.test(userAgent);
        const hasTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
        
        // Atualiza o estado apenas se houver mudança real de categoria
        const novoIsMobile = isMobileUA || (isSmallScreen && hasTouch);
        
        setIsMobile(prevState => {
          if (prevState !== novoIsMobile) return novoIsMobile;
          return prevState;
        });
      }
    };

    window.addEventListener('resize', checkIsMobile);
    window.addEventListener('orientationchange', checkIsMobile);
    
    return () => {
      window.removeEventListener('resize', checkIsMobile);
      window.removeEventListener('orientationchange', checkIsMobile);
    };
  }, [maxWidth]);

 const handleModalReservar = () => {
   setOpenModal(true);
   setOpenMobile(false);
 }

 const handleModalQueroExpor = () => {
   setOpenModalQueroExpor(true);
 }

 const handleModalRenovacao = () => {
   if (modoRenovacao && selectedEstandeInfo?.status_reserva_id === 6) {
     setOpenModalRenovacao(true);
   }
 }

 const handleModalRenovacaoReserva = () => {
   if (modoRenovacao && selectedEstandeInfo?.status_reserva_id === 6) {
     setOpenModalRenovacaoReserva(true);
   }
 }

 const preencherDadosExpositor = (expositor) => {
   if (expositor) {
     setNome(expositor.nome || "");
     setEmail(expositor.email || "");
     setTelefone(expositor.telefone || "");
     setCNPJCi(expositor.cnpj_cpf || "");
     setCep(expositor.cep || "");
     setEndereco(expositor.endereco || "");
     setCidade(expositor.cidade || "");
     setEstado(expositor.estado || "");
     }
 };

 useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    const fetchData = async () => {
     try {
      
      const response = await fetch(`${api.API_URL}/comercial/${idFeira}`, {
         signal,
       });

       if (!response.ok) {
         navigate("/nao-encontrada");
         throw new Error("Erro ao buscar os dados");
       }

       const result = await response.json();

      if (!result.status || !result.retorno?.dados || !result.retorno.dados.configuracao?.[0]) {
        navigate("/nao-encontrada");
        throw new Error("Dados da feira incompletos ou inválidos");
      }

       const { dados, geral } = result.retorno;
       const configuracao = dados.configuracao[0];
       const isRenovacaoAtiva = dados.renovacao || false;

       const currentPath = location.pathname;
      
      if (currentPath.includes('/renovacao/')) {
        if (!isRenovacaoAtiva) {
          navigate("/mapa-desativado");
          return;
        }

        if (!configuracao.renovacao_externa) {
          navigate("/mapa-desativado");
          return;
        }
      }

      if (currentPath.includes('/vendas/')) {
        if (!result.retorno.dados.habilitada_vendas) {
          navigate("/mapa-desativado");
          return;
        }

        if (!configuracao.venda_externa) {
          navigate("/mapa-desativado");
          return;
        }
      }
      
       const camposObrigatorios = [
         configuracao.cor_principal,
         configuracao.cor_secundaria,
         dados.nome,
         dados.whatsapp,
         geral.link_termos_uso_evomap
       ];
      
       if (camposObrigatorios.some(campo => !campo)) {
         navigate("/nao-encontrada");
         throw new Error("Campos obrigatórios não preenchidos");
       }

       const mapa = result.retorno.mapa;

       if (
         mapa?.mapa?.mapName &&
         mapa?.mapa?.paths &&
         mapa.mapa.width &&
         mapa.mapa.height
       ) {
         const mapaFormatado = {
           mapName: mapa?.mapa?.mapName,
           width: Number(mapa.mapa.width),
           height: Number(mapa.mapa.height),
           paths: mapa?.mapa?.paths,
         };
         setMapData(mapaFormatado);
         setFundoImagem(result.retorno.fundo);
         const imagem = result.retorno.fundo;
         const nomeCompleto = imagem.split('/').pop(); 
         const nomeSemExtensao = nomeCompleto.split('.')[0];
         const url = new URL(result.retorno.fundo);
         const caminhoSemArquivo = url.origin + url.pathname.substring(0, url.pathname.lastIndexOf('/'));
         
         setFundoImagemMobile(caminhoSemArquivo+'/'+nomeSemExtensao+'_mobile.webp');
         setMapLoading(false);
       } else {
         console.error("Erro: mapa inválido");
         setMapLoading(false);
       }

       setData(result);
       setStatusReserva(configuracao);
       setCorPrincipal(configuracao.cor_principal);
       setCorSecundaria(configuracao.cor_secundaria);
       setLogoDesenvolvedorMapa(configuracao.tem_logo_expositor_mapa ? configuracao.logoDesenvolvedorUrl : null);
       setContrato(geral.link_termos_uso_evomap);
       setCamposRenovacao(dados.campos_renovacao);
       setConfiguracao(configuracao);
       setCorLivre(configuracao.cor_status_livre);
       setCorVendido(configuracao.cor_status_vendido);
       setCorReservado(configuracao.cor_status_reservado);
       setCorRenovacao(configuracao.cor_renovacao);
       setCorPlanoFundo(configuracao.cor_plano_fundo);
       
       setCorPendenteRenovacao(configuracao.cor_pendente_renovacao);
       
      const bannerUrl = configuracao.bannerUrl || geral.bannerUrl;
      if (bannerUrl) setBanner(bannerUrl);

      const bannerMobileUrl = configuracao.bannerMobileUrl || geral.bannerUrl;
      if (bannerMobileUrl) setBannerMobile(bannerMobileUrl);

       setWhatsappPrincipal(dados.whatsapp);
       setNomeFeira(dados.nome);
       setMensagemPadrao(configuracao.mensagem_padrao_comercial || "");
       setModoRenovacao(dados.renovacao || false);
      
       await loadEstantesCadastrados();
       setDadosProntos(true);

     } catch (error) {
       if (error.name !== "AbortError") {
         console.error("Erro ao buscar os dados:", error);
         setError(error.message);
         navigate("/nao-encontrada");
       }
     } finally {
       setLoading(false);
     }
   };

   fetchData();

   return () => controller.abort();
 }, [idFeira, navigate]);

 useEffect(() => {
   const carregarLegenda = async () => {
     try {
       const response = await fetch(
         `${api.API_URL}/feira/tiposEspaco/${idFeira}`,
         {
           headers: { chave: "18266602-6085-4532-992d-7bc2750b19f4" },
         }
       );
       const tiposEspaco = await response.json();
      
       setLegenda(tiposEspaco.data);
      
     } catch (error) {
       console.error("Erro ao carregar o JSON:", error);
     }
   };


   carregarLegenda();
 }, [idFeira]);

 useEffect(() => {
   const carregarPaises = async () => {
     try {
       const response = await fetch(`${api.API_URL}/paises`, {
         headers: { chave: "18266602-6085-4532-992d-7bc2750b19f4" }
       });
       const paises = await response.json();
       setPaises(paises.data);
     
     } catch (error) {
       console.error("Erro ao carregar o JSON:", error);
     }
   };


   carregarPaises();
 }, [idFeira]);

 const [mensagem, setMensagem] = useState("");
 const [tipoMensagem, setTipoMensagem] = useState("");

 useEffect(() => {
    const checkMobile = () => {
      if (forceMobile) {
        setIsMobile(true);
      } else {
        setIsMobile(window.innerWidth <= maxWidth);
      }
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, [maxWidth, forceMobile]);

  const limparCampos = () => {
    setNome("");
    setCNPJCi("");
    setEmail("");
    setTelefone("");
    setFormaPagamentoId("");
    setComercialId("");
    setCondicaoPagamentoId("");
    setObservacao("");
    setEndereco("");
    setEstado("");
    setCep("");
    setCidade("");
    setPais("");
    setTermos(false);
    setErroCampoVazio(false);
  };

 const loadEstantesCadastrados = async () => {
   setLoadingEstandes(true);
   try {
     const response = await fetch(`${api.API_URL}/feira/estandes/${idFeira}`, {
       headers: { chave: "18266602-6085-4532-992d-7bc2750b19f4" },
     });
     const data = await response.json();
    
     setEstandesCadastrados(data.data);
   
     const estandesHashMap = new Map(data.data.map(estande => [estande.hash_path, estande]));
     setEstandesMap(estandesHashMap); 

     return data.data;
   } catch (err) {
     console.error("Erro ao carregar estandes:", err);
     return [];
   } finally {
     setLoadingEstandes(false);
   }
 };

 useEffect(() => {
   if (!mapData?.paths || !Array.isArray(statusDoEstande?.data)) return;

   statusDoEstande.data.forEach((estande) => {
     const codeCorrespondente = Object.keys(mapData.paths).find(
       (key) => mapData.paths[key].hash === estande.hash_path
     );


     if (codeCorrespondente) {
       const pathElement = document.querySelector(
         `[data-code="${codeCorrespondente}"]`
       );
       if (pathElement) {
         if (estande.status_reserva_id === 2) {
           pathElement.setAttribute("fill", corReservado);
           pathElement.setAttribute("data-original-fill", corReservado);
         } else if (estande.status_reserva_id === 3) {
           pathElement.setAttribute("fill", corVendido);
           pathElement.setAttribute("data-original-fill", corVendido);
         } else {
           pathElement.setAttribute("fill", corLivre);
           pathElement.setAttribute("data-original-fill", corLivre);
         }
       }
     }
    
   });
 }, [mapData, corReservado, corVendido, corLivre, statusDoEstande]);

 const handleReservar = () => {
   setMapaDeReserva(true);
 };

 const recarregarEstandes = async () => {
   const estandesAtualizados = await loadEstantesCadastrados();
 };

 const getReservaUrl = () => {
   if (!modoRenovacao) {
     return `${api.API_URL}/comercial/reserva/`;
   }
  
   return selectedEstandeInfo?.status_reserva_id === 6
     ? `${api.API_URL}/comercial/reservaRenovacao`
     : `${api.API_URL}/comercial/reserva/`;
 };

  const handleConfirmarReserva = async (e) => {
    e.preventDefault();
    
   const camposObrigatorios = [
     { valor: formaPagamentoId, nome: "Forma de Pagamento" },
     { valor: condicaoPagamentoId, nome: "Condição de Pagamento" },
     { valor: nome, nome: "Nome" },
     { valor: email, nome: "Email" },
     { valor: telefone, nome: "Telefone" },
    //  { valor: termos, nome: "Termos e Condições" },
     { valor: comercialId, nome: "Comercial" },
   ];

   const camposVazios = camposObrigatorios.filter((campo) => !campo.valor);

   if (camposVazios.length > 0) {
     setErroCampoVazio(
       `Os seguintes campos são obrigatórios: ${camposVazios
         .map((c) => c.nome)
         .join(", ")}`
     );
     return;
   }


   const dadosDeReserva = {
     estande_id: selectedEstandeInfo.id,
     feira_id: idFeira,
     forma_pagamento_id: parseInt(formaPagamentoId),
     condicao_pagamento_id: parseInt(condicaoPagamentoId),
     observacao: observacao,
     comercial_id: parseInt(comercialId),
     expositor: {
       cnpj_codigo_internacional: cnpjCi,
       nome: nome,
       email: email,
       telefone: telefone,
       logo: logo,
       cep: cep,
       endereco: endereco,
       pais: pais,
       estado: estado,
       cidade: cidade
     },
   };


   try {
     setIsLoading(true);
     const url = getReservaUrl();

     const response = await fetch(
       url, {
       method: "POST",
       headers: {
         "Content-Type": "application/json",
       },
       body: JSON.stringify(dadosDeReserva),
     });


     if (response.ok) {
       setShowModalConfirmado(true);


       setTimeout(() => {
         setShowModalConfirmado(false);
         setOpenModal(false);
         limparCampos();
         setSelectedEstandeInfo(null);
       }, 4000);


       await recarregarEstandes();


     } else {
       const errorData = await response.json();
       console.error("Erro na API:", errorData);
       setErroCampoVazio(errorData.message || "Erro ao processar reserva");
     }
   } catch (error) {
     console.error("Erro de conexão:", error);
     setErroCampoVazio("Falha na conexão com o servidor");
   } finally {
     setIsLoading(false);
   }
 };

 const norm = s => (s ?? "")
   .toString()
   .trim()
   .toLowerCase()
   .normalize("NFD")
   .replace(/[\u0300-\u036f]/g, "");

   const termoDeBusca = (estande) => {
   const exps = Array.isArray(estande?.expositor) ? estande.expositor : (estande?.expositor ? [estande.expositor] : []);

   const camposBusca = [];

   exps.forEach(e => {
     if (e?.nome_mapa) camposBusca.push(norm(e.nome_mapa));
     if (e?.nome) camposBusca.push(norm(e.nome));
     if (e?.nome_fantasia) camposBusca.push(norm(e.nome_fantasia));
   });

   if (estande?.nome) {
     camposBusca.push(norm(estande.nome));
   }

   return camposBusca.join(" ");
 };

  const handleAplicarFiltros = () => {
   setSelectedEstandeInfo(null);
   const aprovados = estandesCadastrados
     .filter((estande) => {
       const nomeFiltro = String(filtros.nome || '').toLowerCase();
     
       const filtro = norm(nomeFiltro);


       const passaNosFiltros =
         (filtros.valorMin === "" || estande.valor_total_geral >= parseFloat(filtros.valorMin)) &&
         (filtros.valorMax === "" || estande.valor_total_geral <= parseFloat(filtros.valorMax)) &&
         (filtros.areaMin === "" || estande.area >= parseFloat(filtros.areaMin)) &&
         (filtros.areaMax === "" || estande.area <= parseFloat(filtros.areaMax)) &&
         (filtros.alturaMin === "" || estande.altura_minima >= parseFloat(filtros.alturaMin)) &&
         (filtros.alturaMax === "" || estande.altura_maxima <= parseFloat(filtros.alturaMax)) &&
         (nomeFiltro === "" ||
           estande.nome.toLowerCase().includes(nomeFiltro) ||
           filtro === "" || termoDeBusca(estande).includes(filtro));


       return passaNosFiltros;
     })
     .map(e => e.hash_path);


   setFilteredHashes(aprovados);
   setEstaFiltrado(aprovados.length > 0);
   setLabelsTick(t => t + 1);
 };

 const handleRemoverFiltros = async () => {
   setSelectedEstandeInfo(null);
   setMostrarFiltros(false);
   setEstaFiltrado(false);
   setFiltros({
     valorMax: "",
     valorMin: "",
     alturaMin: "",
     alturaMax: "",
     areaMin: "",
     areaMax: "",
     nome: ""
   });


   setFilteredHashes([]); // <- array vazio
   setLabelsTick(t => t + 1);
 };

 const [imagemFundo, setImagemFundo] = useState(null);

 const adicionarImagem = (dados) => {
   setImagemFundo(dados);
 };

 const contextValues = {
   imagemFundo,
   adicionarImagem,
   mapRef,
   legenda,
   selectedEstandeInfo,
   estandeClicado,
   animationKey,
   setSelectedEstandeInfo,
   openModal,
   setOpenModal,
   openModalSucesso,
   setOpenModalSucesso,
   handleConfirmarReserva,
   reservaConfirmada,
   scale,
   setScale,
   mapaDeReserva,
   setMapaDeReserva,
   handleReservar,
   data,
   formaPagamentoId,
   setFormaPagamentoId,
   comercialId,
   setComercialId,
   condicaoPagamentoId,
   setCondicaoPagamentoId,
   observacao,
   setObservacao,
   cnpjCi,
   setCNPJCi,
   nome,
   setNome,
   email,
   setEmail,
   telefone,
   setTelefone,
   logo,
   setLogo,
   erroCampoVazio,
   setErroCampoVazio,
   setMostrarFiltros,
   mostrarFiltros,
   filtros,
   setFiltros,
   handleAplicarFiltros,
   estandeAlugado,
   mapData,
   corReservado,
   corLivre,
   endereco,
   setEndereco,
   estado,
   setEstado,
   cep,
   setCep,
   cidade,
   setCidade,
   pais,
   setPais,
   corVendido,
   handleRemoverFiltros,
   mensagemEstandeAlugado,
   showModalConfirmado,
   termos,
   setTermos,
   openModalRenovacoes,
   setOpenModalRenovacoes,
   loading,
   loadingEstandes,
   error,
   contrato,
   isLoading,
   limparCampos,
   corPrincipal,
   corPlanoFundo,
   corSecundaria,
   corPendenteRenovacao,
   recarregarEstandes,
   openModalWhatsapp,
   setOpenModalWhatsapp,
   whatsappPrincipal,
   nomeFeira,
   modoRenovacao,
   setModoRenovacao,
   mostrarMapaGeral,
   setMostrarMapaGeral,
   tipoMensagem,
   mensagem,
   logoDesenvolvedorMapa,
   banner,
   bannerMobile,
   contrato,
   paises,
   estandesCadastrados,
   fundoImagem,
   isMobile,
   openMobile,
   setOpenMobile,
   handleModalReservar,
   setEstandesCadastrados,
   mensagemPadrao,
   openModalQueroExpor,
   setOpenModalQueroExpor,
   handleModalQueroExpor,
   idFeira,
   dadosProntos,
   openModalRenovacao,
   setOpenModalRenovacao,
   handleModalRenovacao,
   handleModalRenovacaoReserva,
   emailRenovacao,
   setEmailRenovacao,
   mapLoading,
   camposRenovacao,
   configuracao,
   setOpenModalRenovacaoReserva,
   openModalRenovacaoReserva,
   corRenovacao,
   setShowModalConfirmado,
   nomeFeira,
   fundoImagemMobile,
   filteredHashes,
   setFilteredHashes,
   estaFiltrado,
   setEstaFiltrado,
   labelsTick,
   estandesMap,
   acessoRenovacaoLiberado,
   setAcessoRenovacaoLiberado,
   modalAviso, setModalAviso, exibirAviso,
   preencherDadosExpositor
 };

 return (
   <FeiraContext.Provider value={contextValues}>
     {children}
   </FeiraContext.Provider>
 );
};


FeiraProvider.propTypes = {
 children: PropTypes.node.isRequired,
 idFeira: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};


export const useFeira = () => {
 return useContext(FeiraContext);
};
